import { render, staticRenderFns } from "./RedefinePasswordComponent.vue?vue&type=template&id=5181dc6f&scoped=true"
import script from "./RedefinePasswordComponent.vue?vue&type=script&lang=js"
export * from "./RedefinePasswordComponent.vue?vue&type=script&lang=js"
import style0 from "./RedefinePasswordComponent.vue?vue&type=style&index=0&id=5181dc6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181dc6f",
  null
  
)

export default component.exports